import { Box, Drawer, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";

import { useRoleContext } from "../../hooks";
import { CarrierNavBarItems } from "./components/CarrierNavBarItems";
import { ShipperNavBarItems } from "./components/ShipperNavBarItems";

const drawerWidth = 100;

const DrawerHeader = styled("div")(({ theme }) => ({
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  justifyContent: "flex-end",
}));

export function NavigationBar() {
  const { pathname } = useLocation();
  const { role } = useRoleContext();

  return (
    <Drawer
      id="root-navigation-drawer"
      variant="permanent"
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#0d2e45",
        },
      }}
    >
      <DrawerHeader style={{ paddingTop: "1rem" }}>
        <Link href="/">
          <img
            style={{
              height: "80px",
              width: "80px",
              cursor: "pointer",
            }}
            src="/images/e_logo.jpg"
            alt="Evotrux Logo"
          />
        </Link>
      </DrawerHeader>
      <Box py="1rem">
        {role?.type === "SHIPPER" && <ShipperNavBarItems pathName={pathname} />}
        {role?.type === "CARRIER" && <CarrierNavBarItems pathName={pathname} />}
      </Box>
    </Drawer>
  );
}
